const getAuthBaseUrl = () => (typeof window !== 'undefined' ? window.location.host : process.env.AUTH0_BASE_URL);

export const Env = {
  isDev: () => process.env.NODE_ENV === 'development',
  isProd: () => process.env.NODE_ENV === 'production',
  isLocalhost: () => String(getAuthBaseUrl()).includes('localhost'),
  isDevHost: () => !!String(getAuthBaseUrl()).match(/app-dev\./),
  isProdDeployment: () => process.env.PROD_DEPLOYMENT === 'true',
};
